module.exports = __webpack_public_path__ + "img/cardF.a8175afe.png";